import React from "react";
import RootLayout from "./src/components/layout/RootLayout";
import "./src/styles/global.css";
import { GatsbyBrowser } from "gatsby";

/**
 * Przy pierwszym wejściu na URL z #kotwicą przeglądarka przewija przed pełną hydratacją/układem
 * (obrazy, fonty) — scroll-padding-top nie pomaga, jeśli pozycja jest policzona za wcześnie.
 */
function scheduleScrollToHash() {
  if (typeof window === "undefined") return;
  const { hash } = window.location;
  if (!hash || hash === "#") return;
  const id = decodeURIComponent(hash.slice(1));
  if (!id) return;

  const scroll = () => {
    const el = document.getElementById(id);
    el?.scrollIntoView({ behavior: "auto", block: "start" });
  };

  scroll();
  requestAnimationFrame(() => {
    scroll();
    requestAnimationFrame(scroll);
  });
  window.setTimeout(scroll, 0);
  window.setTimeout(scroll, 100);
  window.setTimeout(scroll, 350);
  window.addEventListener("load", scroll, { once: true });
  if (document.fonts?.ready) {
    void document.fonts.ready.then(scroll);
  }
}

export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] = () => {
  scheduleScrollToHash();
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (location.hash) {
    scheduleScrollToHash();
  }
};

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => <RootLayout>{element}</RootLayout>;
